import { createContext } from 'use-context-selector'

export const ContextMenuContext = createContext<{ closeContextMenu: (cb?: () => void) => void }>({
  closeContextMenu: () => {}
})
